import type {ReactElement} from 'react';
import React from 'react';
import {PosterEditingBaseColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/poster-editing-base-color-panel';
import type {ColorStorage} from '@Components/color-picker-v2';
import type {RGBA} from '@Utils/color.util';
import {getRGBAArrayFromColorStorage} from '@Utils/color.util';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTabItem} from '@Hooks/poster-editor/useGetKeyFromTabItem';

export function SeparatorColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const itemSeparatorColor = useGetKeyFromTabItem('separatorColor');

  if (!activeItem) {
    throw new Error('Active Item is null');
  }

  if (!activeItem.isTab() || !itemSeparatorColor) {
    throw new Error(`Expected tab item, instead got ${activeItem.gitype}`);
  }

  const getColor = (): ColorStorage[] => {
    return getColorObjectArrayFromFillColor([itemSeparatorColor]);
  };

  const updateFillColor = (fillColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        separatorColor: fillColor,
      },
      {undoable}
    );
  };

  const onChangeColor = (updatedColor: ColorStorage[]): void => {
    updateFillColor(getRGBAArrayFromColorStorage(updatedColor)[0], false);
  };
  const onChangeColorEnded = (updatedColor: ColorStorage[]): void => {
    updateFillColor(getRGBAArrayFromColorStorage(updatedColor)[0]);
  };

  return <PosterEditingBaseColorPanel id="separator-color-panel" color={getColor()} onChangeColor={onChangeColor} onChangeEnded={onChangeColorEnded} />;
}
